// extracted by mini-css-extract-plugin
export default {"container":"loader_container__U4ZCv","lds_ring":"loader_lds_ring__TTzh0"};